import AttachmentsEmpty from './AttachmentsEmpty';

export default AttachmentsEmpty;
